import { serviceGlyph } from '../lib/format';

/**
 * One extra-service icon, as the legacy rows draw it: the old extranet's
 * Flaticon glyph where it had one (cleaning, fuel, car wash, shampooing),
 * else the plain symbol (valet ✈, charging 🔌, a plus). The title names the
 * service; the catalogue title wins when the caller has it.
 */
export function ServiceIcon({ id, title }: { id: number; title?: string }) {
  const g = serviceGlyph(id);
  const t = title ?? g.title;
  return g.icon ? (
    <i className={`flaticon flaticon-${g.icon}`} title={t} aria-label={t} role="img" />
  ) : (
    <span title={t} aria-label={t} role="img">
      {g.glyph}
    </span>
  );
}
